import React, {useState, useCallback, useRef, useEffect} from 'react'
import ReactDOM from 'react-dom'
import {useNavigate, useLocation} from 'react-router'
import {useDispatch, useSelector} from 'react-redux'
import {
  KP11GenerateLinkModalBodyStyle,
  KP11GenerateLinkModalHeaderStyle,
  KP11GenerateLinkModalWrapStyle,
} from '../kp-11Link-order-summary/kp-11Link-order-summary-styles'
import {useAuthClient} from '../../../../utils/use-auth-client'
import {useAsync} from '../../../../utils/use-async'
import {useAuth0} from '@auth0/auth0-react'
import {toast} from 'react-toastify'
import dayjs from 'dayjs'
import {KPLoadingTimelineModal} from '../kp-11Link-order-summary/kp-11Link-timeline'
import styled from '@emotion/styled'
import {keyframes} from '@emotion/react'
import {kP11LinkService} from '../kp-11Link-utility/kp11-service'
import {
  selectPartnerAC,
  selectUserRoles,
  selectEffectiveRole,
} from '../../../../app-store/selector'
import {
  CC_CURRENCIES,
  COUNTRIES,
  KEAP_ADDONS_PARENT_CODES,
  KEAP_FAMILY_CODES,
  KEAP_FAMILY_LEGACY_CODES,
  KEAP_FAMILY_LEGACY_ANNUAL_CODES,
  KEAP_ADDONS_PARENT_LEGACY_CODES,
  NEW_THRYV_LEAD_CODE,
  NEW_THRYV_LEAD_TAX_CODE,
  // KEAP_ADDONS_PARENT_NON_LEGACY_CODES,
  // KEAP_ADDONS_PARENT_CODES,
} from '../../../../utils/constants'
import {getUserRoles} from '../../../../utils/get-user-roles'
import {useUserFeatures} from '../../../../context/user-features-context'
import {
  initializeKP11Cart,
  selectKP11CentersNAppVList,
  selectKeapTextVoiceQuantity,
  selectKeapAddContactsQuantity,
  selectKeapLegacyGraphlyContactsQuantity,
  selectKeapLegacyPlusThisPremiumQuantity,
  resetToDefaultCart,
} from '../../../../app-store/kp11CartSlice'
import {
  resetLinkType,
  selectedInfluencerName,
  selectedLinkType,
} from '../../../../app-store/kpGlobalStateSlice'
import {AccountFailedModalComponent} from '../../../account-failed-modal'
import {isInternationalTaxIdCountry} from '../../../../utils/country-registry'

// Helper function to get currency based on country code
const getCurrencyForCountry = countryCode => {
  if (!countryCode) return 'USD'

  // Find the country in COUNTRIES constant to get the value key
  const country = Object.values(COUNTRIES).find(c => c.isoValue === countryCode)
  if (country && CC_CURRENCIES[country.value]) {
    return CC_CURRENCIES[country.value]
  }

  // Fallback to USD if country not found
  return 'USD'
}

export const getErrorMessage = error => {
  if (!error) return 'Unknown error'
  if (typeof error === 'string') return error

  const message =
    error.message || error.data?.message || error.data?.error || error.error
  if (message) {
    return error.status ? `${message} (${error.status})` : message
  }

  try {
    return JSON.stringify(error)
  } catch {
    return String(error)
  }
}

const compact = value => (Array.isArray(value) ? value.filter(Boolean) : [])

const kpGenerateLinkSpin = keyframes`
  to { transform: rotate(360deg); }
`
export const GenerateLinkOverlay = styled.div`
  position: fixed;
  inset: 0;
  background: rgba(0, 0, 0, 0.6);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 99999;
`
export const GenerateLinkCard = styled.div`
  background: #ffffff;
  border-radius: 12px;
  padding: 40px 48px;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 20px;
  box-shadow: 0 20px 60px rgba(0, 0, 0, 0.3);
  min-width: 260px;
`
export const GenerateLinkSpinnerRing = styled.div`
  width: 56px;
  height: 56px;
  border: 5px solid #f0f0f0;
  border-top-color: #ff5000;
  border-radius: 50%;
  animation: ${kpGenerateLinkSpin} 0.8s linear infinite;
`
export const GenerateLinkSpinnerLabel = styled.p`
  color: #231f20;
  font-size: 15px;
  font-weight: 600;
  margin: 0;
  letter-spacing: 0.01em;
`
export const GenerateLinkSubLabel = styled.p`
  color: #888;
  font-size: 13px;
  margin: 0;
`

export const KPGenerateBuyNowLink = ({generatedBuyNowLink, loading}) => {
  const [linkCopied, setLinkCopied] = useState(false)
  const navigate = useNavigate()
  const dispatch = useDispatch()

  const handleCopy = useCallback(async () => {
    if (!generatedBuyNowLink) return
    try {
      await navigator.clipboard.writeText(generatedBuyNowLink)
      setLinkCopied(true)
      setTimeout(() => setLinkCopied(false), 5000)
    } catch (err) {
      console.error('Failed to copy: ', err)
    }
  }, [generatedBuyNowLink])

  return (
    <KP11GenerateLinkModalWrapStyle>
      <KP11GenerateLinkModalHeaderStyle>
        Generated Link
      </KP11GenerateLinkModalHeaderStyle>

      {loading ? (
        <div className="link-loader">Generating Link...</div>
      ) : (
        <KP11GenerateLinkModalBodyStyle>
          <div className="input-label">Generated URL</div>
          <div className="g-link-wrap">
            <div className="g-link">{generatedBuyNowLink}</div>
            <button
              onClick={handleCopy}
              className={`gl-copy-btn ${linkCopied ? 'gl-copied-btn' : ''}`}
            >
              {linkCopied ? 'Copied' : 'Copy'}
            </button>
          </div>

          <div className="gl-home-btn-wrap">
            <button
              className="gl-home-btn"
              onClick={() => {
                dispatch(initializeKP11Cart)
                dispatch(resetToDefaultCart)
                dispatch(resetLinkType)
                navigate('/')
              }}
            >
              Home
            </button>
          </div>
        </KP11GenerateLinkModalBodyStyle>
      )}
    </KP11GenerateLinkModalWrapStyle>
  )
}
export const KPGenerateURLComponent = ({
  selectedCountry,
  transitionData,
  setIsLinkGenerated,
  onLinkGenerated,
  onError,
}) => {
  const location = useLocation()
  const [showErrorAccountModal, setShowErrorAccountModal] = useState(false)
  const [errorAccountModalMessage, setErrorAccountModalMessage] = useState(null)
  const client = useAuthClient()
  const {run} = useAsync({
    status: 'pending',
  })
  const {user} = useAuth0()

  const {switchedRole, isSwitchRoleUser} = useSelector(selectUserRoles)
  const partnerAffiliateCode = useSelector(selectPartnerAC)
  const keapTextVoiceQuantity = useSelector(selectKeapTextVoiceQuantity)
  const keapAddContactsQty = useSelector(selectKeapAddContactsQuantity)
  const keapLegacyGraphlyContactsQty = useSelector(
    selectKeapLegacyGraphlyContactsQuantity,
  )
  const keapLegacyPlusThisPremiumQty = useSelector(
    selectKeapLegacyPlusThisPremiumQuantity,
  )
  const bundleId = useSelector(state => state.user.bundleId)

  const userRoles = getUserRoles(user)
  const effectiveRole = useSelector(selectEffectiveRole)
  const {TL_Tax_Plan_Enabled: isNewTLPlanEnabled = false} = useUserFeatures()
  const isInfluencerOps =
    (Array.isArray(effectiveRole) && effectiveRole.includes('InfluencerOps')) ||
    userRoles.includes('InfluencerOps')

  const planPrices = useSelector(selectKP11CentersNAppVList)
  const influencerName = useSelector(selectedInfluencerName)
  const linkType = useSelector(selectedLinkType)

  // Priority order for keapPartnerId:
  // 1. InfluencerOps → use logged-in user's email (user.email from Auth0)
  // 2. Switched role to KeapPartner → use partnerAffiliateCode from Redux
  // 3. Else → use keapPartnerId from transitionData or partnerDetails
  let keapPartnerId = null
  if (isInfluencerOps) {
    keapPartnerId = user?.email
  } else if (
    isSwitchRoleUser &&
    switchedRole.length &&
    switchedRole?.[0] === 'KeapPartner'
  ) {
    keapPartnerId = partnerAffiliateCode
  } else {
    keapPartnerId = transitionData?.keapPartnerId
      ? transitionData?.keapPartnerId
      : transitionData?.partnerDetails?.keapPartnerId
  }

  console.log({transitionData})

  const [generatedLink, setGeneratedLink] = useState('')
  const [isLoadingTimelineCompleted, setLoadingTimelineCompletionStatus] =
    useState(true)
  const [isLoadingCompleted, setLoadCompletionStatus] = useState(true)
  const [isGenerating, setIsGenerating] = useState(true)

  const currentStep = useRef(1)
  const generationStartedRef = useRef(false)
  //   const [captureOrderId, setCaptureOrderId] = useState(null)
  const [paymentUUID, setPaymentUUID] = useState('')
  const [orderId, setOrdreId] = useState('')
  const [thryvId, setThryvId] = useState('')

  console.log(
    currentStep,
    isLoadingCompleted,
    isLoadingTimelineCompleted,
    setLoadCompletionStatus,
    setLoadingTimelineCompletionStatus,
  )

  useEffect(() => {
    if (generationStartedRef.current) return
    generationStartedRef.current = true

    async function triggerAccSetup() {
      if (linkType === '1:1') {
        try {
          await triggerAccSetupApiCall()
        } catch (err) {
          setIsGenerating(false)
          onError?.()
          return
        }
      } else {
        await generateUrlFunc({uuid: paymentUUID, order_id: orderId})
      }
    }
    triggerAccSetup()
  }, [])

  async function updateKeapClientPartnerLink(
    url,
    uuid,
    captureOrderID,
    order_id,
  ) {
    await run(
      client('keappartner/updateKeapPartnerLinks', {
        method: 'PUT',
        data: {
          generated_url: url,
          cc_order_id: order_id,
          order_id: captureOrderID,
          payment_uuid: uuid,
          email: user.email,
        },
      }),
    )
  }

  function getProductDetails() {
    const selectedProducts = transitionData.selectedCentersNApps || {}
    let productDetails = {
      centers: compact(selectedProducts.centers).filter(item => item?.code),
      apps: compact(selectedProducts.apps).filter(item => item?.code),
      oneTimeFees: compact(selectedProducts.oneTimeFees).filter(
        item => item?.code,
      ),
    }
    let parentSubscriptions = []
    const KEAP_ADDONS_MONTHLY_CODE = 'addon-5-keap-addons'
    const KEAP_ADDONS_ANNUAL_CODE = 'addon-5-keap-addons-annual'
    const appCatalogByCode = new Map(
      compact(planPrices?.apps).map(app => [app.code, app]),
    )
    const isKeapAddonWrapperCode = code =>
      String(code || '').startsWith('addon-5-keap-addons')

    const isKeapRecurringChildAddon = item => {
      const code = String(item?.code || '')
      if (!code.startsWith('addon-5-keap-')) return false
      if (isKeapAddonWrapperCode(code)) return false
      return code.endsWith('-m2m') || code.endsWith('-annual')
    }

    const isKeapChildAddon = item => {
      const code = String(item?.code || '')
      if (!code.startsWith('addon-5-keap')) return false
      if (isKeapAddonWrapperCode(code)) return false
      if (isKeapRecurringChildAddon(item)) return true
      const catalogParent = appCatalogByCode.get(item?.code)?.parentProduct
      return (
        isKeapAddonWrapperCode(item?.parentProduct) ||
        isKeapAddonWrapperCode(catalogParent)
      )
    }

    const resolveKeapWrapperFromCode = code =>
      String(code || '').endsWith('-annual')
        ? KEAP_ADDONS_ANNUAL_CODE
        : KEAP_ADDONS_MONTHLY_CODE

    const resolveKeapAddonWrapperCode = item => {
      if (isKeapAddonWrapperCode(item?.code)) {
        return item.code
      }
      if (isKeapAddonWrapperCode(item?.parentProduct)) {
        return item.parentProduct
      }
      // let itemCode =
      //   item?.code ||
      //   item?.parentProduct ||
      //   appCatalogByCode.get(item?.code)?.parentProduct ||
      //   ''
      // if (KEAP_ADDONS_PARENT_CODES.includes(itemCode)) {
      //   return itemCode
      // }
      const catalogParent = appCatalogByCode.get(item?.code)?.parentProduct
      if (isKeapAddonWrapperCode(catalogParent)) {
        return catalogParent
      }
      if (isKeapChildAddon(item)) {
        return resolveKeapWrapperFromCode(item?.code)
      }
      return null
    }

    const hasKeapFamilyCenterInOrder = [
      ...(productDetails?.centers || []),
      ...(productDetails?.apps || []),
    ].some(
      ({code} = {}) =>
        KEAP_FAMILY_CODES.includes(code) ||
        KEAP_FAMILY_LEGACY_CODES.includes(code) ||
        KEAP_FAMILY_LEGACY_ANNUAL_CODES.includes(code),
    )

    const keapChildAddonsByWrapper = (productDetails?.apps || [])
      .filter(isKeapChildAddon)
      .reduce((result, app) => {
        const wrapperCode = resolveKeapAddonWrapperCode(app)
        if (!wrapperCode) return result
        if (!result[wrapperCode]) {
          result[wrapperCode] = []
        }
        result[wrapperCode].push(app)
        return result
      }, {})

    const wrapperCodesInOrder = (productDetails?.apps || [])
      .filter(({code}) => isKeapAddonWrapperCode(code))
      .map(({code}) => code)

    const wrapperCodesToSend = Array.from(
      new Set([
        ...Object.keys(keapChildAddonsByWrapper),
        ...wrapperCodesInOrder,
      ]),
    )

    let childSubscriptions = []
    if (productDetails?.centers && productDetails.centers.length > 0) {
      for (let center of productDetails.centers) {
        if (center?.code?.startsWith('cc_')) {
          parentSubscriptions.push(center)
        } else {
          childSubscriptions.push(center)
        }
      }
    }
    let isLegacyKeapAddonParentCodeExist = wrapperCodesToSend.some(item =>
      KEAP_ADDONS_PARENT_LEGACY_CODES.includes(item),
    )

    //forming child subscriptions
    if (hasKeapFamilyCenterInOrder && wrapperCodesToSend.length > 0) {
      // Keap Add Ons subscriptions (monthly and/or annual)
      if (!isLegacyKeapAddonParentCodeExist) {
        wrapperCodesToSend.forEach(wrapperCode => {
          const selectedWrapperAddons =
            keapChildAddonsByWrapper[wrapperCode] || []
          if (
            !selectedWrapperAddons.length &&
            !wrapperCodesInOrder.includes(wrapperCode)
          )
            return

          childSubscriptions.push({
            code: wrapperCode,
            quantity: 1,
            addons: selectedWrapperAddons.map(item => {
              let quantity = item.quantity
              if (String(item.code).includes('addon-5-keap-textvoice')) {
                quantity = keapTextVoiceQuantity ?? 1
              }
              if (String(item.code).includes('addon-5-keap-addcontacts')) {
                quantity = keapAddContactsQty ?? 1
              }
              if (String(item.code).includes('keap-legacy-graphly')) {
                quantity = keapLegacyGraphlyContactsQty ?? 1
              }
              if (String(item.code).includes('keap-legacy-plusthis')) {
                quantity = keapLegacyPlusThisPremiumQty ?? 1
              }
              return {
                ...item,
                quantity,
              }
            }),
          })
        })
      }
    }

    let marketplace = productDetails?.centers.find(
      ({code}) => code === 'appmarket-5-thryv-m2m',
    )
    if (!marketplace) {
      marketplace = productDetails?.apps.find(
        ({code}) => code === 'appmarket-5-thryv-m2m',
      )
    }

    // checking for legacy keap center product
    let isLegacyKeapCenter = productDetails?.centers.find(
      item => item.code.includes('legacy') && item.code.includes('keap'),
    )
    let legacyProductList = new Set()
    let productList = [
      ...productDetails.centers,
      ...productDetails.apps,
      ...productDetails.oneTimeFees,
    ]
    productList.map(item => {
      ;(item?.legacyProducts || []).map(lp => {
        legacyProductList.add(lp)
        return lp
      })
      return item
    })

    if (isLegacyKeapCenter || isLegacyKeapAddonParentCodeExist) {
      let keapAddonsParentCode = productDetails?.apps?.find(item =>
        KEAP_ADDONS_PARENT_CODES.includes(item.code),
      )
      let keapAddonsList =
        (
          productDetails?.apps?.filter(
            item =>
              item.code.includes('addon-5-keap') &&
              !KEAP_ADDONS_PARENT_CODES.includes(item.code),
          ) || []
        ).map(({code, quantity = 1}) => {
          if (code.includes('keap-textvoice')) {
            quantity = keapTextVoiceQuantity ?? 1
          } else if (code.includes('keap-addcontacts')) {
            quantity = keapAddContactsQty ?? 1
          } else if (code.includes('keap-legacy-graphly')) {
            quantity = keapLegacyGraphlyContactsQty ?? 1
          } else if (code.includes('keap-legacy-plusthis')) {
            quantity = keapLegacyPlusThisPremiumQty ?? 1
          }
          return {
            code,
            quantity,
          }
        }) || []
      if (keapAddonsParentCode) {
        childSubscriptions.push({
          code: keapAddonsParentCode.code,
          quantity: 1,
          addons: [...keapAddonsList],
        })
      }
    }

    if (marketplace?.code) {
      childSubscriptions.push({
        code: marketplace.code,
        quantity: 1,
        addons: [
          // Include existing marketplace addons
          ...(Array.isArray(marketplace?.addons) ? marketplace.addons : []),
          ...(productDetails?.apps
            .filter(({name, code, parentProduct}) => {
              if (isKeapChildAddon({code, name, parentProduct})) return false
              if (
                code === 'maxhvac-5-thryv-m2m' ||
                code === 'maxroof-5-thryv-m2m' ||
                code === 'maxelect-5-thryv-m2m' ||
                code === 'maxplumb-5-thryv-m2m' ||
                code === 'vert_mc_clientsvcs-5-thryv-m2m' ||
                code === 'vert_mc_web_clientsvcs-5-thryv-m2m' ||
                code === 'vert_clientsvcs-5-thryv-m2m' ||
                code === 'vert_svcs-5-thryv-m2m' ||
                code === 'appmarket-5-thryv-m2m' ||
                code === 'vert_mc_clientsvcs-5-thryv-ot' ||
                code === 'vert_mc_web_clientsvcs-5-thryv-ot' ||
                code === 'vert_clientsvcs-5-thryv-ot' ||
                code?.includes('keap') ||
                code === 'tp_add-5-thryv-m2m' ||
                code === '247support-m2m' ||
                code === 'addon-5-seopb-m2m' ||
                code === 'addon-5-seokey-m2m'
              ) {
                return false
              }
              return (
                name !== 'AEO & SEO' &&
                name !== 'Thryv Leads' &&
                // name !== 'Keap Max' &&
                name !== 'Leads Lift' &&
                !code?.startsWith('tl-')
              )
            })
            .map(({code, quantity = 1, unitAmount}) => {
              return {
                code,
                quantity,
                ...(unitAmount != null ? {unitAmount} : {}),
              }
            }) || []),
        ],
      })
    }

    // Hanlde new Alpha SEO
    const newAlphaSEO = productDetails?.apps.find(
      ({code}) => code === 'seobase-5-thryv-m2m',
    )

    if (newAlphaSEO) {
      const keyword = productDetails?.apps.find(
        ({code}) => code === 'addon-5-seokey-m2m',
      )
      const powerboost = productDetails?.apps.find(
        ({code}) => code === 'addon-5-seopb-m2m',
      )

      const seoSubscription = {
        code: newAlphaSEO.code,
        quantity: newAlphaSEO.amount || newAlphaSEO.quantity || 1,
        addons: [],
      }

      if (keyword) {
        seoSubscription.addons.push({
          code: keyword.code,
          quantity: keyword.quantity,
        })
      }

      if (powerboost) {
        seoSubscription.addons.push({
          code: powerboost.code,
          quantity: powerboost.quantity,
        })
      }

      childSubscriptions.push(seoSubscription)
    }
    if (newAlphaSEO) {
      childSubscriptions = childSubscriptions.map(subscription => {
        if (
          subscription.code === 'seobase-5-thryv-m2m' &&
          subscription.quantity === 1
        ) {
          return {
            ...subscription,
            quantity: newAlphaSEO.amount,
            amount: 1,
          }
        }
        return subscription
      })
    }
    for (let app of productDetails.apps) {
      if (app?.name === 'Thryv Leads' || app?.code.startsWith('tl-')) {
        childSubscriptions.push(app)
      } else if (
        app?.code === 'vert_mc_clientsvcs-5-thryv-m2m' ||
        app?.code === 'vert_mc_web_clientsvcs-5-thryv-m2m' ||
        app?.code === 'vert_clientsvcs-5-thryv-m2m' ||
        app?.code === 'vert_mc_clientsvcs-5-thryv-ot' ||
        app?.code === 'vert_mc_web_clientsvcs-5-thryv-ot' ||
        app?.code === 'vert_clientsvcs-5-thryv-ot' ||
        app?.code === 'vert_svcs-5-thryv-m2m'
      ) {
        childSubscriptions.push(app)
      } else if (KEAP_FAMILY_CODES.includes(app?.code)) {
        childSubscriptions.push(app)
      }
    }
    legacyProductList = Array.from(legacyProductList)

    let oneTimeFees = [...productDetails.oneTimeFees]
    childSubscriptions = childSubscriptions.filter(item => {
      return item?.code && !legacyProductList.includes(item.code)
    })
    childSubscriptions = childSubscriptions.map(item => {
      let data = {...item}
      let addons = (data?.addons || []).filter(
        addon => addon?.code && !legacyProductList.includes(addon.code),
      )
      data['addons'] = addons
      return data
    })
    oneTimeFees = oneTimeFees.filter(
      item => item?.code && !Array.from(legacyProductList).includes(item.code),
    )
    return {parentSubscriptions, childSubscriptions, oneTimeFees}
  }

  function generateDiscountPayload(discounts = [], order_id) {
    let discountPayload = []
    discounts.map((item, index) => {
      // discountPayload.push({order_id, line_number: index + 1, discount_type: ''})
      let itemDetails = {
        order_id,
        line_number: index + 1,
        discount_percentage: item.discountPercent,
        discount_amount: item.discountAmount,
        coupon_code: item.code,
        discount_type: item.type,
        duration: item.durationAmount,
        start_date: dayjs().format('YYYY-MM-DD'),
        end_date: item.durationAmount
          ? dayjs()
              .add(item.durationAmount, item.durationUnit)
              .format('YYYY-MM-DD')
          : dayjs().format('YYYY-MM-DD'),
      }

      discountPayload.push(itemDetails)
      return item
    })
    return discountPayload
  }

  function generateCreateOrderPayload(
    accInfo,
    accDetails,
    acc,
    linesDetails,
    discounts,
  ) {
    let discountDetails = generateDiscountPayload(discounts) || []
    return {
      order_status: 'Pending',
      order_version: '5.0',
      order_flow: 'New',
      //order_submitted_date: new Date(),
      order_submitted_by: 'null',
      order_completed_date: null,
      industry_id: accInfo.industryId,
      industry_description:
        'For Veterinarians, Groomers, Pet Care Services and more.',
      country_code:
        accInfo.country ||
        selectedCountry ||
        transitionData?.thryvDetail?.selectedCountry,
      account_email: accInfo.email,
      contact_first_name: accInfo.firstName,
      contact_last_name: accInfo.lastName,
      contact_phone: accInfo?.phone || accInfo?.companyPhone || null,
      contact_mobile: accInfo.mobile || null,
      contact_email: accInfo.email,
      company_name: accInfo.company || null,
      company_address1: accInfo.address || null,
      company_address2: null,
      company_city: accInfo.city || null,
      company_state: accInfo?.state?.value || accInfo?.state || null,
      company_zipcode: accInfo?.postalCode || accInfo?.postCode || null,
      company_phone: accInfo?.phone || accInfo?.companyPhone || null,
      abn: accInfo?.abn,
      sales_rep_id: null,
      on_behalf_of: null,
      xp_code: null,
      thryv_id: acc?.thryvId,
      account_code: acc?.ccId || transitionData?.ccId,
      eaid:
        accDetails?.accountInfo?.eaid ||
        transitionData?.EID ||
        'keapClientPlaceHolder',
      is_invoice_billed: 0,
      is_cohort: null,
      demo_lead_id: null,
      no_service: null,
      onboarding_appt_id:
        transitionData?.kickOffCallDetails?.kickOffCallSchedule?.apptId || null,
      creative_appt_id:
        transitionData?.creativeCallDetails?.creativeCallSchedule?.apptId ||
        null,
      update_to_autopay: 1,
      on_boarding_fee: 0,
      purchase_intent_1: null,
      purchase_intent_2: null,
      purchase_intent_3: null,
      sensis_site: null,
      discounts: discountDetails,
      reseller: [],
      keap_account: false,
      lines: linesDetails,
      link_id: transitionData?.state?.linkId,
    }
  }

  function generateLineItem(
    subDetail,
    index,
    parentIndex = null,
    parentSubCode = null,
  ) {
    const planCenters = compact(planPrices?.centers)
    const planApps = compact(planPrices?.apps)
    const planOneTimeFees = compact(planPrices?.oneTimeFees)
    let isCenter = planCenters.find(item => item.code === subDetail.code)
    let isOneTimeFee = planOneTimeFees.find(
      item => item.code === subDetail.code,
    )
    let isApp = planApps.find(item => item.code === subDetail.code)
    let plansv5_id = ''
    let saas_product_category = ''
    let saas_product_type = ''
    let recurly_subscription_id = null
    let unit_cost = 0
    let quantity = 1
    let total_cost = unit_cost * quantity
    let parent_line_number =
      parentIndex !== null ? parentIndex + 1 : parentIndex

    if (isApp) {
      saas_product_category = 'App'
      saas_product_type = 'addon'
      plansv5_id = isApp.id
    } else if (isCenter) {
      saas_product_category = 'Center'
      saas_product_type = 'main'
      plansv5_id = isCenter.id
      unit_cost = isCenter?.unitAmount || 0
      quantity = isCenter?.quantity || 1
      total_cost = unit_cost * quantity
    } else if (isOneTimeFee) {
      saas_product_category = 'OneTimeFee'
      saas_product_type = 'oneTimeFee'
      plansv5_id = isOneTimeFee.id
      unit_cost = isCenter?.unitAmount || 0
      quantity = isCenter?.quantity || 1
      total_cost = unit_cost * quantity
    } else if (subDetail.code === 'appmarket-5-thryv-m2m') {
      saas_product_category = 'App'
      saas_product_type = 'addon'
      plansv5_id = 'wo6lpqm9wsxn'
      unit_cost = isApp?.unitAmount || 0
      quantity = isApp?.quantity || 1
      total_cost = unit_cost * quantity
    }
    if (parentSubCode) {
      saas_product_category = 'App'
      saas_product_type = 'addon'
      if (parentSubCode === 'appmarket-5-thryv-m2m') {
        if (!plansv5_id) {
          plansv5_id = 'wo6lpqm9wsxn'
        } else {
          parent_line_number = null
        }
      } else {
        plansv5_id =
          [...planCenters, ...planApps, ...planOneTimeFees].find(
            item => item.code === parentSubCode,
          )?.id || 'wo6lpqm9wsxn'
      }
    }
    return {
      line_number: index + 1,
      parent_line_number,
      plansv5_id,
      action_code: 'New',
      order_line_status: 'InProgress',
      saas_product_category,
      saas_product_type,
      saas_product_code: subDetail.code,
      saas_instance_id: null,
      recurly_subscription_id,
      total_cost,
      unit_cost,
      quantity,
      start_date: new Date(),
      end_date: null,
    }
  }

  async function postCreateAccCaptureOrderDetailTrigger(
    thryvAccDetail,
    subDetail,
  ) {
    let subDetailsList = [
      ...subDetail.parentSubscriptions,
      ...subDetail.childSubscriptions,
      ...subDetail.oneTimeFees,
    ].filter(item => item?.code)
    let subLines = []
    let count = 0

    for (let i = 0; i < subDetailsList.length; i++) {
      const parentCount = count
      subLines.push(generateLineItem(subDetailsList[i], count))
      const addons = compact(subDetailsList[i].addons).filter(
        addon => addon?.code,
      )
      if (addons.length > 0) {
        for (let j = 0; j < addons.length; j++) {
          count += 1
          subLines.push(
            generateLineItem(
              addons[j],
              count,
              parentCount,
              subDetailsList[i].code,
            ),
          )
        }
      }
      count += 1
    }
    let couponsDetails = []
    if (transitionData?.couponList) {
      couponsDetails = [...couponsDetails, ...transitionData.couponList]
    }
    if (transitionData?.defaultIncentive) {
      couponsDetails = [...couponsDetails, ...transitionData.defaultIncentive]
    }
    let createCaptureOrderPayload = generateCreateOrderPayload(
      transitionData.accountInformation,
      {},
      thryvAccDetail,
      subLines,
      couponsDetails,
    )

    let captureOrderResponse = await run(
      client('ordercapture/services/createOrder', {
        method: 'POST',
        data: createCaptureOrderPayload,
      }),
    )
    // if (captureOrderResponse.Success) {
    //   setCaptureOrderId(captureOrderResponse.order_id)
    // }
    return captureOrderResponse.order_id
  }

  function formatInCodeQuantityStructure(
    subDetails,
    isNewThryvLeadsSale = false,
  ) {
    let parentSubscriptions = []
    let childSubscriptions = []
    let oneTimeFees = []
    const resolveOutboundCode = code =>
      isNewThryvLeadsSale && isNewTLPlanEnabled && code === NEW_THRYV_LEAD_CODE
        ? NEW_THRYV_LEAD_TAX_CODE
        : code
    console.log('subDetails:===?', {subDetails})

    const hasMonthlyLegacyWrapper = subDetails.childSubscriptions.some(
      item => item.code === 'addon-5-keap-addons-legacy-m2m',
    )
    const hasAnnualLegacyWrapper = subDetails.childSubscriptions.some(
      item => item.code === 'addon-5-keap-addons-legacy-annual',
    )

    subDetails.parentSubscriptions.map(item => {
      let customFields = {}
      if (item?.customFields) {
        customFields = {customFields: item?.customFields}
      }
      let tempDetails = {
        code: resolveOutboundCode(item.code),
        quantity: item?.quantity || 1,
        addons: [],
        ...customFields,
      }
      let tempAddons = []
      const itemAddons = compact(item?.addons).filter(subItem => subItem?.code)
      if (itemAddons.length > 0) {
        itemAddons.map(subItem => {
          let customFields = {}
          if (subItem?.customFields) {
            customFields = {customFields: subItem?.customFields}
          }
          tempAddons.push({
            code: resolveOutboundCode(subItem.code),
            quantity: subItem?.quantity || 1,
            ...customFields,
          })
          return subItem
        })
      }
      tempDetails.addons = tempAddons
      parentSubscriptions.push(tempDetails)
      return item
    })
    subDetails.childSubscriptions.map(item => {
      // Skip the normal wrapper if the legacy one is already present.
      // `return` exits early before childSubscriptions.push(), so the item is excluded from the payload.
      if (hasMonthlyLegacyWrapper && item.code === 'addon-5-keap-addons')
        return item
      if (hasAnnualLegacyWrapper && item.code === 'addon-5-keap-addons-annual')
        return item
      let customFields = {}
      if (item?.customFields) {
        customFields = {customFields: item?.customFields}
      }
      let tempDetails = {
        code: resolveOutboundCode(item.code),
        quantity: item?.quantity || 1,
        addons: [],
        ...customFields,
      }
      if (
        item.code.includes('tl-mc-5-thryv-m2m') &&
        item?.customFields?.futureBillingDate
      ) {
        tempDetails['startDate'] = item?.customFields?.futureBillingDate
      }
      let tempAddons = []
      const itemAddons = compact(item?.addons).filter(subItem => subItem?.code)
      if (itemAddons.length > 0) {
        itemAddons.map(subItem => {
          let customFields = {}
          if (subItem?.customFields) {
            customFields = {customFields: subItem?.customFields}
          }
          tempAddons.push({
            code: resolveOutboundCode(subItem.code),
            quantity: subItem?.quantity || 1,
            ...customFields,
          })
          return subItem
        })
      }
      tempDetails.addons = tempAddons
      childSubscriptions.push(tempDetails)
      return item
    })
    subDetails.oneTimeFees.map(item => {
      let tempDetails = {
        code: resolveOutboundCode(item.code),
        quantity: item?.quantity || 1,
        addons: [],
      }
      let tempAddons = []
      const itemAddons = compact(item?.addons).filter(subItem => subItem?.code)
      if (itemAddons.length > 0) {
        itemAddons.map(subItem => {
          tempAddons.push({
            code: resolveOutboundCode(subItem.code),
            quantity: subItem?.quantity || 1,
          })
          return subItem
        })
      }
      tempDetails.addons = tempAddons
      oneTimeFees.push(tempDetails)
      return item
    })

    return {
      parentSubscriptions,
      childSubscriptions,
      oneTimeFees,
    }
  }

  async function generateUrlFunc({
    uuid,
    order_id,
    captureOrderID = null,
    onboardingApptId = null,
    creativeApptId = null,
    isNewThryvLeadsSale = false,
  }) {
    const allApps = compact(transitionData?.selectedCentersNApps?.apps)

    const shouldRemapTL =
      linkType === '1:1' && isNewThryvLeadsSale && isNewTLPlanEnabled
    const resolveOutboundCode = code =>
      shouldRemapTL && code === NEW_THRYV_LEAD_CODE
        ? NEW_THRYV_LEAD_TAX_CODE
        : code

    const KP_WRAPPER_CODES = new Set([
      'addon-5-keap-addons',
      'addon-5-keap-addons-annual',
      'addon-5-keap-addons-legacy-m2m',
      'addon-5-keap-addons-legacy-annual',
    ])
    const isKPWrapper = code => KP_WRAPPER_CODES.has(String(code || ''))
    const isKPChild = code => {
      const c = String(code || '')
      return c.startsWith('addon-5-keap-') && !isKPWrapper(c)
    }

    const wrapperItemKP = allApps.find(app => isKPWrapper(app.code))
    const keapAddonWrapperCode =
      wrapperItemKP?.code ||
      allApps.find(app => isKPWrapper(app.parentProduct))?.parentProduct

    const hasKeapRecurringChildAddon = allApps.some(app => isKPChild(app.code))

    const toAddonShape = app => ({
      code: resolveOutboundCode(app.code),
      quantity: app.quantity ?? 1,
      ...(app.isAlreadyAdded != null
        ? {isAlreadyAdded: app.isAlreadyAdded}
        : {}),
      ...(app.addons?.length
        ? {
            addons: app.addons.map(a => ({
              code: resolveOutboundCode(a.code),
              quantity: a.quantity ?? 1,
            })),
          }
        : {}),
    })

    const keapChildren = allApps.filter(app => isKPChild(app.code))
    const otherApps = allApps.filter(
      app => !isKPChild(app.code) && !isKPWrapper(app.code),
    )

    const addOnCode =
      hasKeapRecurringChildAddon && keapAddonWrapperCode
        ? [
            ...otherApps.map(toAddonShape),
            {
              code: keapAddonWrapperCode,
              quantity: 1,
              addons: keapChildren.map(app => {
                let quantity = app.quantity ?? 1
                if (
                  String(app.code || '').includes('addon-5-keap-addcontacts')
                ) {
                  quantity = parseFloat(keapAddContactsQty) || 1
                } else if (
                  String(app.code || '').includes('addon-5-keap-textvoice')
                ) {
                  quantity = parseFloat(keapTextVoiceQuantity) || 1
                } else if (
                  String(app.code || '').includes('keap-legacy-graphly')
                ) {
                  quantity = parseFloat(keapLegacyGraphlyContactsQty) || 1
                } else if (
                  String(app.code || '').includes('keap-legacy-plusthis')
                ) {
                  quantity = parseFloat(keapLegacyPlusThisPremiumQty) || 1
                }
                return {
                  code: app.code,
                  quantity,
                  ...(app.isAlreadyAdded != null
                    ? {isAlreadyAdded: app.isAlreadyAdded}
                    : {}),
                }
              }),
            },
          ]
        : allApps.map(app => {
            if (String(app.code || '').includes('addon-5-keap-addcontacts')) {
              return {
                ...toAddonShape(app),
                quantity: parseFloat(keapAddContactsQty) || 1,
              }
            }
            if (String(app.code || '').includes('addon-5-keap-textvoice')) {
              return {
                ...toAddonShape(app),
                quantity: parseFloat(keapTextVoiceQuantity) || 1,
              }
            }
            if (String(app.code || '').includes('keap-legacy-graphly')) {
              return {
                ...toAddonShape(app),
                quantity: parseFloat(keapLegacyGraphlyContactsQty) || 1,
              }
            }
            if (String(app.code || '').includes('keap-legacy-plusthis')) {
              return {
                ...toAddonShape(app),
                quantity: parseFloat(keapLegacyPlusThisPremiumQty) || 1,
              }
            }
            return toAddonShape(app)
          })
    let payload = {
      sfPartnerAccountId:
        transitionData?.partnerDetails?.sfPartnerAccountId || '123121',
      keapPartnerId: keapPartnerId,
      countryCode:
        linkType === '1:many'
          ? selectedCountry
          : transitionData?.accountInformation?.country
          ? transitionData?.accountInformation?.country
          : 'US',
      planCode: transitionData?.selectedCentersNApps?.centers || [],
      addOnCode,
      oneTimeFees: transitionData?.selectedCentersNApps?.oneTimeFees || [],
      partnerEmail: user?.email,
      couponCode: null || transitionData?.couponList?.map(item => item.code),
      defaultIncentive:
        null || transitionData?.defaultIncentive?.map(item => item.code),
    }
    if (!keapPartnerId) {
      toast.error('Keap Partner Id value is missing  ')
      return
    }
    const unpricedOneTimeFee = payload.oneTimeFees.find(
      fee => fee?.unitAmount === undefined || fee?.unitAmount === null,
    )
    if (unpricedOneTimeFee) {
      toast.error(
        `Cannot generate the link because ${
          unpricedOneTimeFee.name || unpricedOneTimeFee.code
        } does not have a USD price configured.`,
      )
      return
    }
    if (isInfluencerOps) {
      payload.influencerName = influencerName
    }
    if (bundleId) {
      payload.slp_share_link_id = bundleId
    }
    const generateLink = await run(
      client('cc/order/keap-partner/generate-link', {data: payload}),
    )
    if (generateLink?.generatedUrl) {
      if (linkType === '1:1') {
        await updateKeapClientPartnerLink(
          generateLink?.generatedUrl,
          uuid,
          captureOrderID,
          order_id,
        )
        // In the new-account flow accountInformation is re-fetched and can be empty for
        // a just-created account, so fall back to the verified email carried in
        // navigation state (and transitionData.email). Without a real client email the
        // partner↔client map is orphaned and the account can never surface in My
        // Accounts — so only write the map when we actually resolved one.
        const keapClientEmail =
          transitionData?.accountInformation?.email ||
          transitionData?.email ||
          location?.state?.email ||
          ''
        if (keapClientEmail) {
          await run(
            client('cc/order/keapClient/createClientPartnerMap', {
              data: {
                link_id: generateLink.linkId,
                keap_partner_email: user.email,
                keap_client_email: keapClientEmail,
                status: 'Pending',
              },
            }),
          )
        }
      }

      if (captureOrderID) {
        await run(
          client('ordercapture/services/updateOrderStatus', {
            method: 'PUT',
            data: {
              order_id: Number(captureOrderID),
              rep_id: user.email,
              userEmailId: user.email,
              link_id: generateLink.linkId,
              order_status: 'Submitted',
              onboarding_appt_id: onboardingApptId,
              creative_appt_id: creativeApptId,
              payment_uuid: uuid,
            },
          }),
        )
      }

      setIsLinkGenerated(true)
      let link = generateLink.generatedUrl
      setGeneratedLink(link)
      onLinkGenerated?.(link)
    }
  }

  async function generateSendLinkDetails(
    sendLinkPayLoad,
    captureOrderID,
    retriesCount = 10,
    isNewThryvLeadsSale = false,
  ) {
    try {
      let data = await run(
        client('cc/order/send-link', {
          data: sendLinkPayLoad,
        }),
      )
      currentStep.current = currentStep.current + 1
      if (currentStep.current >= 2) {
        setLoadingTimelineCompletionStatus(true)
        setLoadCompletionStatus(true)
      }

      if (data.message === 'Order created') {
        setPaymentUUID(data.paymentUuid)
        setOrdreId(data.orderId)
      }
      if (currentStep.current >= 2) {
        setLoadCompletionStatus(true)
        setLoadingTimelineCompletionStatus(true)
      }

      await generateUrlFunc({
        uuid: data.paymentUuid,
        order_id: data.orderId,
        captureOrderID,
        onboardingApptId: sendLinkPayLoad.onboardingApptId,
        creativeApptId: sendLinkPayLoad.creativeApptId,
        isNewThryvLeadsSale,
      })
      // return data
    } catch (err) {
      if ([404, 500].includes(err.status)) {
        // if (retriesCount === 0) throw err
        // setTimeout(
        //   async () =>
        //     await generateSendLinkDetails(
        //       sendLinkPayLoad,
        //       captureOrderID,
        //       retriesCount - 1,
        //     ),
        //   9000,
        // )
        // setShowErrorAccountModal(true)
        toast.error(
          `Error occurred while updating the data. Error: ${getErrorMessage(
            err,
          )}`,
        )
        return
      }
    }
  }

  async function captureAppointment(data, orderHeaderId) {
    console.log('new', data)
    const createAppointModel = []
    const appointmentObj = {
      order_id: orderHeaderId,
      schedule_status: 'Scheduled',
      appointment_type: data.appointment_type,
      timezone: data.timeZone,
      appt_id: data.apptId,
      date: data.thryvBookingDate.split('T')[0],
      time: data.thryvBookingDate.split('T')[1],
      title: 'Meeting Connect',
      duration: 30,
      service_id: data.serviceId,
      staff_id: data.staffId,
      interaction: 'call Interaction',
      zoomURL: 'https://www.zoom.com',
      create_user: null,
      update_user: null,
    }
    createAppointModel.push(appointmentObj)
    // console.log(createAppointModel)
    try {
      let result
      let url = 'ordercapture/services/createAppointment'
      result = await kP11LinkService.captureAppoinmentDetail(
        client,
        url,
        createAppointModel,
      )
      console.log(result)
      // if (result.Success) {
      //   const contextData = {
      //     appointment_type: data.appointment_type,
      //     apptId: apptId,
      //   }
      //   captureOrderNewUpgrade(
      //     'capture-appointment',
      //     'new-upgrade',
      //     contextData,
      //   )
      // } else {
      //   console.log(result.message)
      // }
    } catch (error) {
      if (error.status !== 400) {
        console.log('error in captureAppointment', error)
        // throw error
      }
      if (error.errors) {
        console.log('error in captureAppointment', error)
        // throw error
      }
    }
  }

  async function triggerAccSetupApiCall() {
    try {
      const industryId = 'fpdwyu4e6ly3txw0'
      let accountInformation =
        transitionData.accountInformation || location?.state?.accountInformation
      const existingThryvLeadsSub =
        transitionData?.thryvDetail?.subDetails?.childSubscriptions?.find(
          sub =>
            sub?.plan?.code === NEW_THRYV_LEAD_CODE ||
            sub?.plan?.code === 'tl-5-thryv-m2m',
        )
      const isNewThryvLeadsSale = !existingThryvLeadsSub

      const transitionThryvDetail = transitionData?.thryvDetail || {}
      const routeThryvDetail = location?.state?.thryvDetail || {}
      let account = {
        thryvId:
          transitionThryvDetail.thryvId ||
          routeThryvDetail.thryvId ||
          transitionData?.accountCode ||
          transitionData?.childCustomerInfo?.accountCode ||
          location?.state?.accountCode ||
          location?.state?.childCustomerInfo?.accountCode,
        ccId:
          transitionThryvDetail.ccId ||
          routeThryvDetail.ccId ||
          transitionData?.parentCcId ||
          transitionData?.ccId ||
          location?.state?.parentCcId ||
          location?.state?.ccId ||
          transitionThryvDetail.subDetails?.parentSubscriptions?.[0]?.account
            ?.code ||
          routeThryvDetail.subDetails?.parentSubscriptions?.[0]?.account
            ?.code ||
          (transitionThryvDetail.username
            ? `CC_${transitionThryvDetail.username}`
            : null),
      }

      if (!account.thryvId || !account.ccId) {
        setErrorAccountModalMessage(
          'Account IDs are missing. Please create the account before generating the Keap partner link.',
        )
        setShowErrorAccountModal(true)
        return
      }

      const rawAddress = accountInformation?.address
      const addressObject =
        rawAddress && typeof rawAddress === 'object' ? rawAddress : {}
      const addressLine = typeof rawAddress === 'string' ? rawAddress : ''
      const businessAddress = accountInformation?.businessAddress || {}
      const verifyCountry =
        accountInformation?.country ||
        addressObject.country ||
        businessAddress.country ||
        'US'
      const verifyStreet =
        addressObject.street ||
        accountInformation?.street ||
        addressLine ||
        businessAddress.street ||
        businessAddress.address ||
        ''
      const verifyCity =
        accountInformation?.city || addressObject.city || businessAddress.city
      const verifyState =
        accountInformation?.state?.value ||
        accountInformation?.state ||
        addressObject.state ||
        addressObject.region ||
        businessAddress.state ||
        businessAddress.region
      const verifyZipCode =
        accountInformation?.postalCode ||
        accountInformation?.postCode ||
        accountInformation?.zipCode ||
        addressObject.zipCode ||
        addressObject.postalCode ||
        businessAddress.postalCode ||
        businessAddress.postCode ||
        businessAddress.zipCode

      // For the already-existing path (e.g. an Add Location child provisioned via
      // intg-signup, which may live only in intg-signup's Recurly tenant), the account
      // is not guaranteed to exist in the OOE Recurly tenant that the downstream
      // send-link / process-purchase calls bill against. Verify it now — the backend
      // does a GET-or-create in OOE Recurly and returns the authoritative codes — so a
      // missing account is provisioned here instead of failing the customer at payment
      // time. Idempotent, so safe on repeat clicks. Mirrors catalog order-summary.handleContinue.
      try {
        const verified = await run(
          client('accounts/5/verify-account-created', {
            method: 'PATCH',
            data: {
              thryvId: account.thryvId,
              ccId: account.ccId,
              email: accountInformation?.email,
              firstName: accountInformation?.firstName,
              lastName: accountInformation?.lastName,
              company: accountInformation?.company,
              timeZone: accountInformation?.timeZone || 'America/Chicago',
              address: {
                street: verifyStreet,
                city: verifyCity,
                state: verifyState,
                zipCode: verifyZipCode,
                country: verifyCountry,
              },
            },
          }),
        )
        if (verified?.error) {
          setShowErrorAccountModal(true)
          return
        }
        // Adopt the backend-resolved codes — notably the real parent ccId, which it
        // resolves from Recurly even when the input ccId was a best-effort guess.
        if (verified?.thryvId && verified?.ccId) {
          account = {thryvId: verified.thryvId, ccId: verified.ccId}
          transitionData.thryvDetail = transitionData.thryvDetail || {}
          transitionData.thryvDetail.thryvId = verified.thryvId
          transitionData.thryvDetail.ccId = verified.ccId
        }
      } catch (err) {
        if (err.status === 422) {
          setErrorAccountModalMessage(err.message)
        }
        setShowErrorAccountModal(true)
        return
      }

      let customDelayLookupDetail = await run(
        client('keappartner/fetchConfigLookupValue/maxCustomDelayInSeconds'),
      )
      let customDelay = customDelayLookupDetail?.data[0]?.value || 0
      if (customDelay) {
        // create wait sync function with custom delay as lay in seconds

        const waitSync = delayInSeconds => {
          return new Promise(resolve => {
            setTimeout(resolve, delayInSeconds * 1000)
          })
        }

        await waitSync(customDelay)
      }
      if ((account && account?.thryvId) || thryvId.length > 0) {
        setThryvId(account.thryvId)

        let subDetail = getProductDetails()
        const captureOrderID = await postCreateAccCaptureOrderDetailTrigger(
          account,
          subDetail,
        )
        accountInformation = {
          ...accountInformation,
          thryvId: account.thryvId || thryvId,
          industryId,
          isInvoiceBilled: false,
        }
        let coupons = []
        if (transitionData?.couponList) {
          coupons = [
            ...coupons,
            ...transitionData.couponList.map(item => item.code),
          ]
        }
        if (transitionData?.defaultIncentive) {
          coupons = [
            ...coupons,
            ...transitionData.defaultIncentive.map(item => item.code),
          ]
        }
        coupons = [...new Set(coupons)]
        let updatedSubDetails = formatInCodeQuantityStructure(
          subDetail,
          isNewThryvLeadsSale,
        )
        let sendLinkPayloadData = {
          businessAddress: {
            street: accountInformation?.address || '',
            city: accountInformation?.city || '',
            postalCode:
              accountInformation?.postalCode ||
              accountInformation?.postCode ||
              accountInformation?.businessAddress?.postalCode,
            country: accountInformation?.country || 'US',
            phone:
              accountInformation?.phone || accountInformation?.companyPhone,
            state:
              accountInformation?.state?.value || accountInformation?.state,
          },
          ...(['AU', 'NZ'].includes(accountInformation?.country) ||
          isInternationalTaxIdCountry(accountInformation?.country)
            ? {abn: accountInformation?.abn}
            : {}),
          email: accountInformation?.email,
          firstName: accountInformation?.firstName,
          lastName: accountInformation?.lastName,
          contactPhone: accountInformation?.mobile || '',
          currency: getCurrencyForCountry(accountInformation?.country),
          company: accountInformation?.company,
          thryvId: account.thryvId,
          industryId: accountInformation?.industryId,
          flow:
            transitionData.thryvDetail?.thryvId ||
            location?.state?.thryvDetail?.thryvId
              ? 'upgrade'
              : 'new',
          // ...subDetail,
          ...updatedSubDetails,
          coupons: coupons,
          overrideRepId: keapPartnerId,
          behalfRepId: keapPartnerId,
        }
        let isThryvLeadsInCart = sendLinkPayloadData.childSubscriptions.find(
          item =>
            item.code === NEW_THRYV_LEAD_CODE ||
            item.code === NEW_THRYV_LEAD_TAX_CODE,
        )
        const allAppsForSeo = transitionData?.selectedCentersNApps?.apps || []
        const seoAppInCart = allAppsForSeo.find(
          app => app.code === 'seobase-5-thryv-m2m',
        )
        if (isThryvLeadsInCart) {
          sendLinkPayloadData['thryvLeadsId'] =
            isThryvLeadsInCart?.customFields?.thryvLeadsId
        }
        if (seoAppInCart) {
          sendLinkPayloadData['seoDomain'] =
            seoAppInCart?.customFields?.alphaDomain
          sendLinkPayloadData['seoProposalId'] =
            seoAppInCart?.customFields?.alphaProposalId
        }
        const isMCExist = sendLinkPayloadData.childSubscriptions.find(item =>
          item.code.includes('mc_'),
        )
        if (isMCExist && isMCExist?.customFields?.mcDomain) {
          sendLinkPayloadData['mcDomain'] = isMCExist?.customFields?.mcDomain
        }
        const isKeapInCart = sendLinkPayloadData.childSubscriptions.some(
          item =>
            item.code === 'addon-5-keap-addons' ||
            item.code?.startsWith('keap_'),
        )
        if (bundleId && isKeapInCart) {
          sendLinkPayloadData['slp_share_link_id'] = bundleId
        }
        if (
          !transitionData?.kickOffCallDetails?.kickOffCallSchedule?.skipped &&
          transitionData?.kickOffCallDetails?.isKickOffCallScheduled
        ) {
          sendLinkPayloadData['onboardingApptId'] =
            transitionData?.kickOffCallDetails?.kickOffCallSchedule?.apptId ||
            ''
        }
        if (transitionData?.creativeCallDetails?.isCreativeCallScheduled) {
          sendLinkPayloadData['creativeApptId'] =
            transitionData?.creativeCallDetails?.creativeCallSchedule?.apptId ||
            ''
        }
        // scheduled appointment table details
        if (
          !transitionData?.kickOffCallDetails?.kickOffCallSchedule?.skipped &&
          transitionData?.kickOffCallDetails?.isKickOffCallScheduled
        ) {
          await captureAppointment(
            transitionData?.kickOffCallDetails?.kickOffCallSchedule,
            captureOrderID,
          )
        }
        if (transitionData?.creativeCallDetails?.isCreativeCallScheduled) {
          await captureAppointment(
            transitionData?.creativeCallDetails?.creativeCallSchedule,
            captureOrderID,
          )
        }

        if (captureOrderID) {
          sendLinkPayloadData['orderHeaderId'] = captureOrderID
        }
        await generateSendLinkDetails(
          sendLinkPayloadData,
          captureOrderID,
          undefined,
          isNewThryvLeadsSale,
        )
      } else {
        setLoadCompletionStatus(true)
        setLoadingTimelineCompletionStatus(true)
      }
    } catch (err) {
      console.log(err)
      setLoadCompletionStatus(true)
      setLoadingTimelineCompletionStatus(true)

      toast.error(
        `We encountered an error while updating data, Please contact Admin. Error: ${getErrorMessage(
          err,
        )}`,
      )
      throw err
    }
  }

  console.log('generatedLink', generatedLink)
  return (
    <div style={{height: 'auto'}}>
      {generatedLink.length === 0 ? (
        isLoadingTimelineCompleted &&
        isGenerating &&
        ReactDOM.createPortal(
          <GenerateLinkOverlay>
            <GenerateLinkCard>
              <GenerateLinkSpinnerRing />
              <GenerateLinkSpinnerLabel>
                Generating link…
              </GenerateLinkSpinnerLabel>
              <GenerateLinkSubLabel>
                This may take a few moments
              </GenerateLinkSubLabel>
            </GenerateLinkCard>
          </GenerateLinkOverlay>,
          document.body,
        )
      ) : !onLinkGenerated ? (
        <KPGenerateBuyNowLink generatedBuyNowLink={generatedLink} />
      ) : null}
      {!isLoadingTimelineCompleted && (
        <KPLoadingTimelineModal currentStep={currentStep.current} />
      )}
      {showErrorAccountModal && (
        <AccountFailedModalComponent
          errorMessage={errorAccountModalMessage}
          onClose={() => {
            setShowErrorAccountModal(false)
            setErrorAccountModalMessage(null)
          }}
        />
      )}
    </div>
  )
}
